import { Injectable } from '@angular/core';

import { ToastController } from 'ionic-angular';

@Injectable()
export class ToastService {

    constructor(private toastCtrl: ToastController) {
    }

    presentToast(msg:string, css:string) {
        let toast = this.toastCtrl.create({
            message: msg,
            //duration: 3000,
            position: 'top',
            showCloseButton: true,
            cssClass: css
        });

        toast.present();
    }

    error(msg:string) {
        this.presentToast(msg, 'toast-error')
    }

    info(msg:string) {
        this.presentToast(msg, 'toast-info')
    }

    warn(msg:string) {
        this.presentToast(msg, 'toast-warn')
    }

}






// WEBPACK FOOTER //
// ./src/app/shared/toast.service.ts